import { NewsPostDto } from './news-post.dto';

export type NewsPostUpdateRequestDto = Partial<Pick<NewsPostDto, 'commentsAllowed' | 'publicationDate'>>;
